export default "__VITE_ASSET__64e28787__"